<template>
  <div class="introduction-content">
    <div class="article-page">
      <h1 class="article-title">欢迎使用伦理培训视频学习平台</h1>
      <div class="article-date">{{ currentDate }}</div>
      <div class="article-content">
        <div class="intro-section">
          <h2>平台简介</h2>
          <p>本课程为初级伦理培训课程，共12学时。内容涵盖心理服务伦理基本知识、伦理实践、伦理守则解读、伦理与相关法规等。完成本课程并通过考核后，将获得伦理培训合格证书（注：此证书为专项伦理培训证明，并非心理咨询师专业技能培训合格证书，也不等同于心理咨询从业资格证）。<br>

特别提醒： 根据课程平台规则，学员若已解锁两个以上课程视频，将无法申请全额退费，请在开始学习前知悉。</p>
        </div>
        
        <!-- <div class="features-section">
          <h2>平台特色</h2>
          <div class="features-grid">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="el-icon-video-play"></i>
              </div>
              <h3>高质量视频课程</h3>
              <p>由资深专家录制的专业课程，内容权威、实用性强</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">
                <i class="el-icon-medal-1"></i>
              </div>
              <h3>分级认证体系</h3>
              <p>从初级到督导师的完整培训体系，满足不同阶段需求</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">
                <i class="el-icon-document-checked"></i>
              </div>
              <h3>在线测试评估</h3>
              <p>配套测试题目，及时检验学习效果，确保学习质量</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">
                <i class="el-icon-trophy-1"></i>
              </div>
              <h3>权威证书认证</h3>
              <p>完成学习后获得官方认可的继续教育证书</p>
            </div>
          </div>
        </div> -->
        
        <!-- <div class="courses-overview">
          <h2>课程体系</h2>
          <div class="course-levels">
            <div class="level-item">
              <div class="level-badge primary">初级</div>
              <div class="level-info">
                <h4>初级心理咨询师</h4>
                <p>基础理论知识和基本咨询技能培训</p>
              </div>
            </div>
            <div class="level-item">
              <div class="level-badge success">中级</div>
              <div class="level-info">
                <h4>中级心理咨询师</h4>
                <p>深入的咨询技术和案例分析能力培养</p>
              </div>
            </div>
            <div class="level-item">
              <div class="level-badge warning">高级</div>
              <div class="level-info">
                <h4>高级心理咨询师</h4>
                <p>专业咨询技术和复杂案例处理能力</p>
              </div>
            </div>
            <div class="level-item">
              <div class="level-badge danger">督导</div>
              <div class="level-info">
                <h4>心理咨询督导师</h4>
                <p>督导技能和团队管理能力培训</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroductionContent',
  data() {
    return {};
  },
  computed: {
    currentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
}
</script>

<style scoped>
.introduction-content {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.article-page {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.article-title {
  font-size: 2.5em;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #2a91ff, #667eea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.article-date {
  text-align: center;
  color: #666;
  font-size: 1.1em;
  margin-bottom: 40px;
}

.article-content {
  font-size: 1.15em;
  color: #333;
  line-height: 1.8;
}

.intro-section {
  margin-bottom: 40px;
}

.intro-section h2 {
  color: #2a91ff;
  font-size: 1.8em;
  margin-bottom: 20px;
  border-bottom: 2px solid #2a91ff;
  padding-bottom: 10px;
}

.features-section {
  margin-bottom: 40px;
}

.features-section h2 {
  color: #2a91ff;
  font-size: 1.8em;
  margin-bottom: 30px;
  text-align: center;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}

.feature-card {
  background: #f8f9ff;
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #e6f0ff;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(42, 145, 255, 0.15);
  border-color: #2a91ff;
}

.feature-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #2a91ff, #667eea);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 24px;
  color: white;
}

.feature-card h3 {
  color: #333;
  font-size: 1.3em;
  margin-bottom: 15px;
}

.feature-card p {
  color: #666;
  font-size: 0.95em;
  line-height: 1.6;
}

.courses-overview h2 {
  color: #2a91ff;
  font-size: 1.8em;
  margin-bottom: 30px;
  text-align: center;
}

.course-levels {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.level-item {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.level-item:hover {
  transform: translateX(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.level-badge {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  margin-right: 20px;
  font-size: 14px;
}

.level-badge.primary {
  background: linear-gradient(135deg, #2a91ff, #667eea);
}

.level-badge.success {
  background: linear-gradient(135deg, #52c41a, #73d13d);
}

.level-badge.warning {
  background: linear-gradient(135deg, #faad14, #ffc53d);
}

.level-badge.danger {
  background: linear-gradient(135deg, #ff4d4f, #ff7875);
}

.level-info h4 {
  color: #333;
  font-size: 1.3em;
  margin-bottom: 8px;
}

.level-info p {
  color: #666;
  font-size: 0.95em;
  margin: 0;
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .level-item {
    flex-direction: column;
    text-align: center;
  }
  
  .level-badge {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
